import Vue from "vue";
import SignIn from "./index.vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  render(createElement) {
    return createElement(SignIn, {
      props: {
        text: "ログイン"
      }
    });
  }
});
